import { RootState } from '../../../rootReducer';
import { INotificationsListSate } from './types';

export const selectNotificationsList = (state: RootState): INotificationsListSate =>
  state.notifications.list;
